const GET_MONTHWISE_DEPARTMENT_START = 'GET_MONTHWISE_DEPARTMENT_START';
const GET_MONTHWISE_DEPARTMENT_SUCCESS = 'GET_MONTHWISE_DEPARTMENT_SUCCESS';
const GET_MONTHWISE_DEPARTMENT_FAIL = 'GET_MONTHWISE_DEPARTMENT_FAIL';

const getMonthWiseDepartmentStart = () => {
	return {
		type: GET_MONTHWISE_DEPARTMENT_START,
	};
};
const getMonthWiseDepartmentSuccess = (response) => {
	return {
		type: GET_MONTHWISE_DEPARTMENT_SUCCESS,
		response,
	};
};
const getMonthWiseDepartmentFail = (error) => {
	return {
		type: GET_MONTHWISE_DEPARTMENT_FAIL,
		error,
	};
};

export default {
	types: {
		GET_MONTHWISE_DEPARTMENT_START,
		GET_MONTHWISE_DEPARTMENT_SUCCESS,
		GET_MONTHWISE_DEPARTMENT_FAIL,
	},
	creators: {
		getMonthWiseDepartmentStart,
		getMonthWiseDepartmentSuccess,
		getMonthWiseDepartmentFail,
	},
};
